import { TwoFactorSettings } from "@/components/TwoFactorSettings";
import { SupportContactStrip } from "@/components/SupportContactStrip";

export function AdminSecurityPage() {
    return (
        <div className="space-y-6" data-testid="admin-security-page">
            <div className="hidden lg:block">
                <h2 className="font-heading text-xl tracking-tight">Security</h2>
                <p className="mt-1 text-sm text-white/50 max-w-2xl">
                    Super admin accounts must use two-factor authentication. Set up an authenticator app to protect platform-wide access.
                </p>
            </div>
            <TwoFactorSettings apiPrefix="/admin/2fa" required allowDisable={false} />
            <SupportContactStrip variant="security" />
        </div>
    );
}
